import template from './builder-name.jade';
import validation from '../../../services/validation';

export default angular.module('cian.addForm.builderName', []).directive('cianAfAboutBuildingBuilderName', () => ({
  scope: {},
  bindToController: {
    ad: '=',
    form: '=',
  },
  controller: [
    'deviceService',
    function (deviceService) {
      this.isMobile = deviceService.isMobile;
      this.ad.geo.jk = this.ad.geo.jk || {};
      this.ad.geo.jk.developer = this.ad.geo.jk.developer || {};

      this.validation = validation(this.form, 'builderName', {});

      this.hanldeChangeName = () => {
        this.ad.geo.jk.developer.id = null; // сбрасываем Id есди пользователь вводит текст
      };
    },
  ],
  controllerAs: 'builderName',
  template,
})).name;
